import KeycloakService from '../Services/KeycloakService';

const Public = ({ children }) =>
  !KeycloakService.isLoggedIn() ? children : null;

export default Public;
